const newspage = {

    init () {
        
        let newspage = document.getElementById('newspage');

        if(newspage){
    
            let newsLinks = document.getElementsByClassName('newslink');


            let newsSections = document.getElementsByClassName('news-section');
            for(let m=1; m < newsSections.length ; m++){
                newsSections[m].classList.add('displaynone');
            }

        
            for(let i=0; i < newsLinks.length; i++){
        
        
                newsLinks[i].addEventListener('click', e => {
                    
                    e.preventDefault();
                    
                    for(let k=0; k < newsLinks.length; k++){
                        newsLinks[k].classList.remove('active');
                    }
        
                    console.log(e);
                    e.target.classList.add('active');
        
                    let newsSections = document.getElementsByClassName('news-section');
        
                    for(let j=0; j < newsSections.length; j++){
                        newsSections[j].classList.remove('displayflex');
                        newsSections[j].classList.add('displaynone');
                    }
        
                    if(newsLinks[i].classList.contains('publicationslink')){
        
                        let sectionPublications = document.querySelector('.blog-section');
                        sectionPublications.classList.remove('displaynone');
                        //sectionPublications.classList.add('displayflex');
                    }
        
                    if(newsLinks[i].classList.contains('socialnetworklink')){
        
                        let sectionSocialNetwork = document.querySelector('.socialnetwork-section');
                        sectionSocialNetwork.classList.remove('displaynone');
                        sectionSocialNetwork.classList.add('displayflex');
                    }
        
                    if(newsLinks[i].classList.contains('videoslink')){
        
                        let sectionVideos = document.querySelector('.videos-section');
                        sectionVideos.classList.remove('displaynone');
                        sectionVideos.classList.add('displayflex');
                    }
        
        
                })
            }
        
        
        }
        


    }
}

export default newspage;